import { MetaLogo } from '@phosphor-icons/react';
import { SocialMediaCampaigns } from "./Social";

import { HookObject, ListItemsHooks } from "@/plugins/types";
import { Dashboard } from "./Dashboard";

export const onListItems = (hook: HookObject, _, __, { permissions = [] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!permissions.includes("social")) return [];
    return [
      {
        label: "Social",
        icon: <MetaLogo className="text-lg" />,
        href: "/social",
        order: 10
      },
    ];
  }

  if (hook.id === ListItemsHooks.ROUTES) {
    if (!permissions.includes("social")) return [];
    return [
      {
        path: "/social",
        element: <SocialMediaCampaigns name="Social Media Campaigns" />,
        children: [
          {
            path: ":id",
            element: <Dashboard name="Social Media Campaigns" />,
          },
        ],
      },
    ];
  }
};


export { SocialMediaCampaigns };